




import './assets/css/styles.scss';
import { Component, Watch } from 'vue-property-decorator';
import LayoutMain from '@/layouts/LayoutMain.vue';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import LayoutGuest from '@/layouts/LayoutGuest.vue';

@Component({
  components: { LayoutMain, LayoutGuest },
})
export default class App extends mixins(BaseMixin) {
  layoutComponent = 'layout-guest';

  get layout() {
    return `${(this.$route.meta as any).layout || 'layout-guest'}`; // eslint-disable-line
  }

  async mounted() {
    if (this.user && !this.$store.state.socketConnection.isConnected) {
      await this.$store.dispatch('socketConnection/connectSocket', { id: this.user.id });
      // await this.$store.dispatch('connectAgencySocket', { id: this.agency.id });
    }
  }

  @Watch('user')
  async watchUser() {
    if (this.user) {
      await this.$store.dispatch('socketConnection/connectSocket', { id: this.user.id });
      // await this.$store.dispatch('connectAgencySocket', { id: this.agency.id });
    } else {
      await this.$store.dispatch('socketConnection/disconnectSocket');
      // await this.$store.dispatch('disconnectAgencySocket');
      await this.handleLogout();
    }
  }
}
